import ScreenTitle from 'common/components/screenTitle/ScreenTitle';
import React from 'react';
import { useTranslation } from 'react-i18next';
import VisitsReportScreenContent, { VisitsReportScreenProps } from './components/content/VisitsReportScreenContent';


const VisitsReportScreen = ({ geofenceId }: VisitsReportScreenProps) => {
    const { t } = useTranslation();

    return (
        <ScreenTitle title={t('visits_report.list.title')}>
            <VisitsReportScreenContent geofenceId={geofenceId} />
        </ScreenTitle>
    )
}

export default VisitsReportScreen;
